module.exports = __webpack_public_path__ + "static/media/iosevka-ss08-regular.cbbed717.woff2";